export default __webpack_public_path__ + "static/media/ic-instruction-12.02b84987.svg";